<template>
  <div>
    <div class="alert_msg" id="set_withdrawal_pin">
      <div class="alert_msg_pos">
        <div class="alert_msg_dialog">
          <div class="alert_msg_header">
            <div id="alert_title">取款密码</div>
            <div>
              <div id="alert_icon"><img src="/static/image/popup_pin.png" /></div>
            </div>
          </div>
          <div class="alert_msg_body">
            <div class="msg_show"></div>
            <div class="form_show">
              <form>
                <label class="textbox_content">
                  <input type="password" name="security_pin" placeholder="原取款密码" v-model="passwordInfo.password" maxlength="6" oninput="value=value.replace(/[^0-9]/g,'')" id="security_pins" class="pin" />
                  <span toggle="#security_pins" class="toggle_password icon-eye_close"></span>
                </label>
                <label class="textbox_content">
                  <input type="password" name="security_pin" placeholder="新取款密码" v-model="passwordInfo.paypassword" maxlength="6" oninput="value=value.replace(/[^0-9]/g,'')" id="security_pin" class="pin" />
                  <span toggle="#security_pin" class="toggle_password icon-eye_close"></span>
                </label>
                <div class="error_msg_security_pin validation" style="color: red; text-align: left; font-size: 10px; margin-bottom: 16px"></div>
                <label class="textbox_content">
                  <input type="password" name="security_pin_confirmation" v-model="passwordInfo.newpasword" placeholder="再输入一次新的取款密码" maxlength="6" oninput="value=value.replace(/[^0-9]/g,'')" id="security_pin_confirmation" class="pin" />
                  <span toggle="#security_pin_confirmation" class="toggle_password icon-eye_close"></span>
                </label>
                <label class="textbox_content"> </label>
                <div class="error_msg_security_pin_confirmation validation" style="color: red; text-align: left; font-size: 10px; margin-bottom: 16px"></div>
              </form>
            </div>
            <div class="button_area">
              <div class="confirm_btn"><button class="btn w-100" @click="editPassword(2)">保存</button></div>
              <div class="cancel_btn" @click="clreaInfo"><a>取消</a></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main_area">
      <div class="player_profile layout tutorial" v-if="$store.state.token">
        <div class="player_profile_bg">
          <div class="detail_area">
            <div class="img_block">
              <svg class="progress-ring" width="76" height="76">
                <circle stroke="#FFF" stroke-width="2" fill="transparent" r="32" cx="38" cy="38"></circle>
                <circle class="progress-ring__circle" stroke="#00BA91" stroke-width="3" fill="transparent" r="32" cx="38" cy="38"></circle>
              </svg>
              <a @click="$parent.goNav('/account')"><img alt="" style="border-radius: 50%" :src="$store.state.userInfo.avatar ? $store.state.userInfo.avatar : '/static/image/avatar_profile.png'" /> </a>
            </div>
            <div class="name_block">
              <div>
                <a @click="$parent.goNav('/account')"
                  ><span class="fullname">{{ $store.state.userInfo.username || '' }}</span> <img class="safety_img" alt="" src="/static/image/safety.png"
                /></a>
                <a @click="$parent.goNav('/vip')"
                  ><span class="fullname">会员等级：{{ $store.state.userInfo.current_vip }}</span> <img class="safety_img" style="width: 40px; height: auto" alt="" :src="baseURL + $store.state.userInfo.vipname"
                /></a>
              </div>
              <div>
                <img class="balance_img" alt="" src="/static/image/wallet.png" /> {{ $store.state.userInfo.balance }}
                <div style="margin-left: 30px" @click="transall">一键回收</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="player_profile_bottom_card">
        <div class="player_account_management" v-if="$store.state.token">
          <a @click="$parent.goNav('/message?type=0')">
            <div class="icon_circle_card"><img alt="" src="/static/image/mailbox_bg.png" /></div>
            我的信息
          </a>
          <a @click="$parent.goNav('/meyList')">
            <div class="icon_circle_card"><img alt="" src="/static/image/record_bg.png" /></div>
            钱包记录
          </a>
          <a @click="$parent.goNav('/bankCard')">
            <div class="icon_circle_card"><img alt="" src="/static/image/bankcards_bg.png" /></div>
            取款绑定管理
          </a>
          <a class="set_withdrawal_pin" @click="changshow">
            <div class="icon_circle_card"><img alt="" src="/static/image/popup_pin.png" /></div>
            取款密码
          </a>
        </div>
        <div class="tutorial tutorial_cover"></div>
        <div class="tutorial tutorial_instruction"></div>
        <div class="player_info_action layout">
          <a class="block_content" @click="$parent.goNav('/welfare')" href="javascript:;" target="_self" style="border-top: 0" v-if="$store.state.token">
            <div class="icon"><img alt="" src="/static/image/g07.png" /></div>
            <div class="title">福利中心</div>
            <div><img alt="" src="/static/image/arrow_right.png" /></div>
          </a>
          <a class="block_content" @click="$parent.goNav('/vip')" href="javascript:;" target="_self" v-if="!$store.state.token">
            <div class="icon"><img alt="" src="/static/image/g11.png" /></div>
            <div class="title">VIP权益</div>
            <div><img alt="" src="/static/image/arrow_right.png" /></div>
          </a>
          <a class="block_content" href="javascript:;" target="_self" @click="$parent.goNav('/applyList')" v-if="$store.state.token">
            <div class="icon"><img alt="" src="/static/image/g01.png" /></div>
            <div class="title">活动申请记录</div>
            <div><img alt="" src="/static/image/arrow_right.png" /></div>
          </a>
          <a class="block_content" @click="$parent.goNav('/app')" href="javascript:;">
            <div class="icon"><img alt="" src="/static/image/my_appdownload.png" /></div>
            <div class="title">下载APP</div>
            <div><img alt="" src="/static/image/arrow_right.png" /></div>
          </a>
          <a class="block_content" @click="$parent.getAgentLoginUrl" href="javascript:;" target="_self">
            <div class="icon"><img alt="" src="/static/image/my_affiliate.png" /></div>
            <div class="title">代理登陆</div>
            <div><img alt="" src="/static/image/arrow_right.png" /></div>
          </a>
          <a class="block_content" @click="$parent.goNav('/customer')">
            <div class="icon"><img alt="" src="/static/image/my_cs.png" /></div>
            <div class="title">客户服务 <span style="padding-left: 30px; color: #ccc; font-size: 10px">V1.1.1.20220906_m</span></div>
            <div><img alt="" src="/static/image/arrow_right.png" /></div>
          </a>
          <a class="block_content" v-if="!$store.state.token" @click="$parent.goNav('/login?type=0')">
            <div class="icon"><img alt="" src="https://7148ssss.com/m/templateimage/profile/my_login.png" /></div>
            <div class="title">登录</div>
            <div><img alt="" src="https://7148ssss.com/m/templateimage/general/arrow_right.png" /></div>
          </a>
          <a class="block_content" v-if="!$store.state.token" @click="$parent.goNav('/login?type=1')">
            <div class="icon"><img alt="" src="https://7148ssss.com/m/templateimage/profile/my_register.png" /></div>
            <div class="title">注册</div>
            <div><img alt="" src="https://7148ssss.com/m/templateimage/general/arrow_right.png" /></div>
          </a>
          <a class="block_content" @click="$parent.goNav('/apply')" v-if="$store.state.token && $store.state.userInfo.isagent == 0">
            <div class="icon"><img alt="" src="/static/image/my_feedback.png" /></div>
            <div class="title">代理申请</div>
            <div><img alt="" src="/static/image/arrow_right.png" /></div>
          </a>

          <a class="block_content" @click="$parent.goNav('/about')">
            <div class="icon"><img alt="" src="/static/image/my_info.png" /></div>
            <div class="title">关于我们</div>
            <div><img alt="" src="/static/image/arrow_right.png" /></div>
          </a>
          <a class="block_content" @click="$parent.goNav('/setting')" v-if="$store.state.token">
            <div class="icon"><img alt="" src="/static/image/my_settings.png" /></div>
            <div class="title">设置</div>
            <div><img alt="" src="/static/image/arrow_right.png" /></div>
          </a>
          <div style="height: 180px"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'mine',
  data() {
    return {
      baseURL: '',
      show: false,
      passwordInfo: {},
    };
  },
  created() {
    let that = this;
    that.baseURL = sessionStorage.getItem('baseURL') || '';
    let query = that.$route.query;
    console.log(query);
    if (query.show) {
      that.show = true;
    }
  },
  methods: {
    transall() {
      let that = this;
      that.showLoading();
      that.$apiFun
        .post('/api/transall', {})
        .then(res => {
          that.$parent.showTost(1, res.message);

          that.refreshusermoney();
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    refreshusermoney() {
      let that = this;
      that.$apiFun.post('/api/refreshusermoney', {}).then(res => {
        that.hideLoading();
        if (res.code == 200) {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.$store.commit('changUserInfo');
        }
      });
    },
    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    changshow() {
      $('#set_withdrawal_pin').addClass('active').addClass('delay');

      this.passwordInfo = {};
    },
    clreaInfo() {
      this.passwordInfo = {};

      setTimeout(function () {
        $('.alert_msg').removeClass('active');

        $('.alert_msg').removeClass('delay');
        alertCheck = true;
      }, 1500);
    },
    editPassword(pasType) {
      let that = this;
      if (!that.passwordInfo.password) {
        that.$parent.showTost(0, '请输入旧密码');
        return;
      }
      if (!that.passwordInfo.paypassword) {
        that.$parent.showTost(0, '请输入新密码');
        return;
      }
      if (that.passwordInfo.password.length < 6) {
        that.$parent.showTost(0, '请输入正确的旧密码长度');
        return;
      }
      if (that.passwordInfo.paypassword.length < 6) {
        that.$parent.showTost(0, '请输入正确的新密码长度');
        return;
      }
      if (!that.passwordInfo.newpasword) {
        that.$parent.showTost(0, '请输入确认密码');
        return;
      }
      if (that.passwordInfo.newpasword != that.passwordInfo.paypassword) {
        that.$parent.showTost(0, '两次密码不一致！');
        return;
      }
      if (that.passwordInfo.password == that.passwordInfo.paypassword) {
        that.$parent.showTost(0, '新旧密码不能一致！');
        that.passwordInfo = {};
        return;
      }
      let url = pasType == 1 ? '/api/editPassword' : '/api/editPayPassword';

      that.$parent.showLoading();
      that.$apiFun.post(url, that.passwordInfo).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        that.$parent.hideLoading();
        if (res.code == 200) {
          that.$parent.showTost(1, '密码修改成功！');
          that.passwordInfo = {};
          that.clreaInfo();
          if (pasType == 1) {
            sessionStorage.setItem('token', '');
            that.$store.commit('changToken');
            that.$router.push({ path: '/' });
          }
        }
      });
    },
  },
  mounted() {
    let that = this;
    if (that.show) {
      that.changshow();
    }
  },
  updated() {
    let that = this;
    that.baseURL = sessionStorage.getItem('baseURL') || '';
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/mode/mine.vue